const geolocPositionPromise = () => {
  return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject))
}

const storeAndGetGeolocPosition = async () => {
  try {
    const position = await geolocPositionPromise();
    const key = "current_coordinates"
    if (localStorage.getItem(key) === null) {
      localStorage.setItem(key, JSON.stringify({
        'latitude': position.coords.latitude,
        'longitude': position.coords.longitude
      }));
    }
    return (({ latitude, longitude }) => ({ latitude, longitude }))(position.coords)
  } catch (err) {
    console.log("geolocation error or blocked")
  }
}

const currentCoords = () => {
  const key = "current_coordinates"
  if (localStorage.getItem(key)) return JSON.parse(localStorage.getItem(key))
}
